<template>
  <div class="web-ad">
    <div class="header-tool">
      <div class="header-tool-info">
        <Breadcrumb>
          <BreadcrumbItem>首页</BreadcrumbItem>
          <BreadcrumbItem>网站设置</BreadcrumbItem>
          <BreadcrumbItem>活动信息</BreadcrumbItem>
        </Breadcrumb>
        <div class="header-tool-title">活动信息</div>
      </div>
      <div class="header-tool-box">
        <div class="htb-item" @click="showAdd=true;">
          <span>添加首页活动</span>
        </div>
      </div>
    </div>
    <!-- <div class="header-switch">
      <div class="header-switch-text">网站广告的设置</div>
    </div> -->

    <marathonHome ref="marathonHome" />

    <webMarathonAdd
      :show="showAdd" 
      @finish="finish"
      @close="showAdd=false;"
    />
  </div>
</template>

<script>
import marathonHome from "../components/web-marathon-home.vue";
import webMarathonAdd from "../components/web-marathon-add.vue";

export default {
  name: "host-webSet-ad",
  data() {
    return {
      show: false,
      showAdd: false,
    };
  },
  methods: {
    finish() {
      this.$refs.marathonHome.init();
    }
  },
  created() {
  },
  components: {
    marathonHome,
    webMarathonAdd
  }
};
</script>

<style lang="scss" scoped>
.web-ad {
  .header-switch {
    display: flex;
    align-items: center;
    padding: 0 35px 18px 35px;
    background: #fff;
    &-text {
      flex: 1;
      font-size: 14px;
      color: #808080;
    }
    &-box {
      flex: 1;
      text-align: right;
    }
  }
}
</style>